import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ClientImportConfig } from 'src/app/models/import/import.model';
import { ImportService } from 'src/app/services/imports/import.service';

type ImportMode = 'none' | 'templates' | 'smart' | 'client-template';

@Component({
  selector: 'app-import-wizard',
  templateUrl: './import-wizard.component.html',
  styleUrls: ['./import-wizard.component.scss']
})
export class ImportWizardComponent {
  validationActive = false;
  selectedDistId?: number;
  currentView: 'home' | 'employees' | 'customersTanks' = 'home';
  config: ClientImportConfig | null = null;
  mode: ImportMode = 'none';
  selectedModule: 'employees' | 'customers-tanks' | 'client-customers-tanks' | null = null;

  extraTankColumns = [
    {
      headerName: 'Location ID',
      field: 'locationId',
      editable: true,
      cellClass: (params: any) =>
        params.data?.errors?.some((e: string) =>
          e.toLowerCase().includes('locationid')
        )
          ? 'cell-error'
          : '',
      tooltipValueGetter: (params: any) =>
        params.data?.errors?.find((e: string) =>
          e.toLowerCase().includes('locationid')
        )
    }
  ];

  constructor(public activeModal: NgbActiveModal, 
      private _router: Router,
      private importService: ImportService,
      private toastService: ToastrService) {}

  ngOnInit() {
    this.selectedDistId = Number(localStorage.getItem('distid') ?? "");
    if (this.selectedDistId < 1) {
      this.toastService.error(`A distributor must be selected before importing data.`, '', { timeOut: 8000 });
      let url: string = "/dashboard/distributors/distributors";
      this.close();
      this._router.navigate([url]);
    }

    this.importService.config$.subscribe(cfg => {
      this.config = cfg;
    });

    this.importService.loadConfig(this.selectedDistId!);
  }

  chooseMode(mode: ImportMode) {
    this.mode = mode;

    if (mode === 'client-template') {
      this.selectedModule = 'client-customers-tanks';
    }
  }

  openModule(key: 'employees' | 'customers-tanks' | 'client-customers-tanks') {
    this.selectedModule = key;
  }

  returnToWizardHome() {
    this.mode = 'none';
    this.selectedModule = null;
  }

  backToModules() {
    this.selectedModule = null;
  }

  backToStart() {
    this.mode = 'none';
    this.selectedModule = null;
  }

  close() {
    this.activeModal.dismiss();
  }
  
}

